import React, { useState, useEffect } from 'react'
import { Field } from 'formik'
import { TextField, Select, MenuItem, FormControl, InputLabel, FormHelperText } from '@material-ui/core'
import { useSelector } from 'react-redux';
import axios from 'axios'
import { ApiURL } from '../constants/ApiUrl'


function FormPage3({ errors, touched, values, setFieldValue }) {
    const States = useSelector(state => state.FormDataReducer.states)
    const [stateList, setStateList] = useState([]);   // 25 oct  jyoti
    const [cityList, setCityList] = useState([])   
  
         // 25 oct jyoti added for NMO state list and prant list from database

    const [SName, setSName] = useState('');
    const [CName, setCName] = useState('');

    useEffect(() => {
        a();
        if (values.state != "") {
            stateChanged(values.state)
        }
    }, [])
    var s = []
    const a = async () => {
        const result = await axios.get(`${ApiURL}/api/get_states`);

        console.log(result.data, "api result..")
        result.data.forEach(element => {
            console.log(element.state_name, "ellee")
            s.push(element.state_name)
        });
        setStateList(s)
    }
    useEffect(() => {
        setCName(values.city);
        //25 oct jyoti
    }, [values.state, values.city])                            // changed city list and state list 
    // these are coming from DB ---- >>>>>>>>
    const stateChanged = async (e) => {
        setSName(values.state);
        setFieldValue("state", e);
        const result = await axios.post(`${ApiURL}/api/get_city`, {            // addinng API for getting prant
            "state": e
        });
        setCityList(result.data.district_name)
       
    }

    const cityChanged = (e) => {
        setFieldValue("city", e.target.value);
    }
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="norFlexCon">
                <div className="ctrl">

                    <Field name="line1" label="Address Line 1 *" as={TextField} variant="outlined" fullWidth error={touched.line1 && errors.line1} helperText={touched.line1 && errors.line1} />
                </div>
                <div className="ctrl">

                    <Field name="line2" label="Address Line 2" as={TextField} variant="outlined" fullWidth error={touched.line2 && errors.line2} helperText={touched.line2 && errors.line2} />
                </div>
                <div className="ctrl">

                    <FormControl variant="outlined" fullWidth error={touched.state && errors.state}>
                        <InputLabel id="stateLabel">State *</InputLabel>
                        <Field name="state" label="State *" labelId="stateLabel" as={Select} value={SName} variant="outlined" onChange={(e)=>stateChanged(e.target.value)} fullWidth error={touched.state && errors.state} helperText={touched.state && errors.state} >
                            <MenuItem value=''>Select State</MenuItem>
                            {
                                stateList.map((item, index) => {
                                    // <option key={index} value={item}>{item}</option>
                                    return <MenuItem key={index} value={item}>{item}</MenuItem>

                                })
                            }
                            {/* {States.map((item, index) => (
                            <MenuItem key={index} value={item.state}>{item.state}</MenuItem>
                        ))} */}
                        </Field>
                        <FormHelperText error>{touched.state && errors.state}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">

                    <FormControl variant="outlined" fullWidth error={touched.city && errors.city}>
                        <InputLabel id="cityLabel">City *</InputLabel>
                        <Field name="city" label="City *" as={Select} variant="outlined" fullWidth value={CName} onChange={cityChanged} error={touched.city && errors.city} helperText={touched.city && errors.city}>
                            <MenuItem value=''>Select City</MenuItem>
                            {
                                cityList.map((item, index) => {

                                    return <MenuItem key={index} value={item}>{item}</MenuItem>

                                })
                            }
                        </Field>
                        <FormHelperText error >{touched.city && errors.city}</FormHelperText>
                    </FormControl>
                </div>
                <div className="ctrl">

                    <Field name="pincode" label="Pin Code *" as={TextField} variant="outlined" fullWidth error={touched.pincode && errors.pincode} helperText={touched.pincode && errors.pincode} />
                </div>
            </div>
        </div>
    )
}

export default FormPage3
